module.exports = __webpack_public_path__ + "static/media/custom.81782195.svg";